import { create } from "zustand";

/**
 * Cross-component signal: which landing chat, if any, has a founder-authored
 * message on screen right now — so the header's Sign In link (LandingNav) can
 * route a mid-chat click through /onboarding/complete instead of dropping the
 * in-progress idea (LEV-1925).
 *
 * `null` means no chat with a user message is mounted; the header falls back
 * to a bare `/sign-in`. The home landing's chat needs its own value distinct
 * from "no chat" — it publishes `""` (never a valid partner slug), while a
 * partner lander publishes its slug. Both non-null values reach
 * `buildMidChatSignInHref` unchanged; only `""` skips the `?from=`/`?src=`
 * params it would otherwise add.
 */
interface LandingChatPresenceState {
  midChatSlug: string | null;
  setMidChatSlug: (slug: string | null) => void;
}

export const useLandingChatPresenceStore = create<LandingChatPresenceState>((set) => ({
  midChatSlug: null,
  setMidChatSlug: (slug) => set({ midChatSlug: slug }),
}));
